function TodoList({ todos, filter, search, onFilterChange, onSearchChange, onToggleDone, onDelete, onEdit, onClearAll, formatDeadline, getDeadlineColor }) {
  if (!todos.length) return null;

  return (
    <section className="todo-wrapper">
      <div className="toolbar">
        <input
          type="text"
          placeholder="Cari tugas..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />

        <select
          value={filter}
          onChange={(e) => onFilterChange(e.target.value)}
        >
          <option value="all">Semua</option>
          <option value="done">Selesai</option>
          <option value="not-done">Belum selesai</option>
        </select>
      </div>

      <ul className="todo-list">
        {todos.map((todo) => (
          <li
            key={todo.id}
            className={`task-card ${todo.done ? "done" : ""}`}
          >
            <div className="task-content">
              <span className="task-text">{todo.text}</span>
              <span
                className="task-deadline"
                style={{ color: getDeadlineColor(todo.deadline, todo.done) }}
              >
                {formatDeadline(todo.deadline)}
              </span>
            </div>
            <div className="todo-buttons">
              {!todo.done && (
                <button
                  type="button"
                  onClick={() => onEdit(todo.id)}
                  className="icon-btn"
                  title="Edit tugas"
                >
                  ✏️
                </button>
              )}
              <button
                type="button"
                onClick={() => onToggleDone(todo.id)}
                className="icon-btn"
                title={todo.done ? "Batal selesai" : "Tandai selesai"}
              >
                {todo.done ? "↺" : "✔"}
              </button>
              <button
                type="button"
                onClick={() => onDelete(todo.id)}
                className="icon-btn danger"
                title="Hapus tugas"
              >
                🗑
              </button>
            </div>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className="clear-btn"
        onClick={onClearAll}
      >
        Hapus Semua
      </button>
    </section>
  );
}

export default TodoList;
